export class IMastersOption {
  constructor() {
    this.id = null;
    this.master_id = null;
    this.label = null;
    // this.slug = null;
  }
}
